module.exports = __webpack_public_path__ + "5e0a3a0e56acffbab84a146ffd031e15.svg";